import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Job, Project, DateTimeFormatPipe } from '@app/shared';
import { DocumentSegment } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class JobService implements RequestService {


  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'campaign';  // URL to web api

  constructor(
    private http: HttpClient,
    private datePipe: DateTimeFormatPipe
    ) { }


  /** GET product by id. Will 404 if id not found */
  /**
  &include=documentSegments.publicOffers
  &include=documentSegments.offerAllocation.publicOffers
  &include=documentSegments.offerAllocation.publicOffers.offerType
  &include=documentSegments.publicOffers.offerType */
  getJobs(code:string): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/${code}/jobs?include=campaignRegions&include=documentSegments&include={"path":"documentSegments","sort":"segmentNumber"}&sort=isMaster&dir=DESC&include=documentSegments.offerAllocation&include=documentSegments.publicOffers&include=documentSegments.offerAllocation.publicOffers&include=documentSegments.offerAllocation.publicOffers.offerType&include=documentSegments.publicOffers.publicOfferAssets&include=documentSegments.publicOffers.offerType`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Job[]>(encodeURI(url),{
       headers: headers
    })
  }

  getJobPages(code:string): Observable<any> {
    const url = `${environment.baseURL}job/${code}/pages?include=campaignPiece.campaignRegions.name`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Job>(url,{
       headers: headers
    })
  }

  getJob(job:Job): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/${job.id}/job`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Job>(url,{
       headers: headers
    })
  }

  addPagesToRegion(jobUUID:string, pages:string, regionName:string): Observable<any> {
    const url = `${environment.baseURL}job/${jobUUID}/add`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    urlSearchParams.append('pages',pages);

    if(regionName)
      urlSearchParams.append('region',regionName);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
      headers: headers
    });

  }


  assignTeamsAndOfferAlloc(allocations:any): Observable<any> {
    const url = `${environment.baseURL}offerallocation/assign/teams`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    let data = JSON.stringify(allocations);

    urlSearchParams.append('data',data);

    const bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
      headers: headers
    });

  }


  updateJob(job:Job): Observable<any> {
    
    const url = `${environment.baseURL}job/save`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    let data = JSON.stringify(job);
    // Object.keys(job).forEach(function (key) {
    //   if(ignoreKeys.indexOf(key) === -1)
    //     urlSearchParams.append(key, job[key]);
    // });
    urlSearchParams.append('data',data);
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
      headers: headers
    });

  }

  copyJob(jobs:Job[],includeOffers:boolean,includeTeams:boolean): Observable<any> {
    
    const url = `${environment.baseURL}job/copy`;
    const ignoreKeys = ['data'];
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    let data = {
      includeOffers:includeOffers?'true':'false',
      includeTeams:includeTeams?'true':'false'
    }

    Object.keys(data).forEach(function (key) {
      if(ignoreKeys.indexOf(key) === -1)
         urlSearchParams.append(key, data[key]);
    });
    
    urlSearchParams.append('data',JSON.stringify(jobs));
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
      headers: headers
    });

  }

  deleteJob(job:Job): Observable<any> {

    const url = `${environment.baseURL}job/delete`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('jobUUID',job.uuid);
    
    const bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
       headers: headers
    })

  }

  setJobLock(code:string,lockStatus:string): Observable<any> {
    const url = `${environment.baseURL}job/lock`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('jobUUID',code);
    urlSearchParams.append('lockStatus',lockStatus);

    const bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
       headers: headers
    })
  }

  swapSegments(jobs:Job[],ds1:DocumentSegment, ds2:DocumentSegment): Observable<any> {

    const url = `${environment.baseURL}page/swap`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();
    var data = [];
    // loop over the jobs and set the correct documentSegment uuids.

    jobs.map(job => {
      // find the first document segment
      let seg1 = job.documentSegments.find(ds => ds.segmentNumber === ds1.segmentNumber);
      let seg2 = job.documentSegments.find(ds => ds.segmentNumber === ds2.segmentNumber);

      if(seg1 && seg2)
        data.push({jobUUID:job.uuid,firstPageUUID:seg1.uuid, secondPageUUID:seg2.uuid});

      if(!seg1 && seg2) {
        data.push({jobUUID:job.uuid,firstPageUUID:"emptyPage#"+ds1.segmentNumber, secondPageUUID:seg2.uuid});  
      } 
      
      if(seg1 && !seg2) {
        data.push({jobUUID:job.uuid,firstPageUUID:seg1.uuid, secondPageUUID:"emptyPage#"+ds2.segmentNumber});
      }
      
      if (!seg1 && !seg2) {
        data.push({jobUUID:job.uuid,firstPageUUID:"emptyPage#"+ds1.segmentNumber, secondPageUUID:"emptyPage#"+ds2.segmentNumber});
      }  
    })

    console.log(data);
    urlSearchParams.append('data',JSON.stringify(data));
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
        headers: headers
    })
  }

  getJobStudioFiles(code:string): Observable<any> {
    
    //code = "307fffeb-5078-4468-afdd-439282d6c611";

    const url = `${environment.baseURL}job/${code}/filegraph`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Job>(url,{
        headers: headers
    })
  }

  loadJobss(): Observable<any> {
    const body = { rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}`;

    let jobs = this.createJobs();
    return Observable.from(jobs);

  }

  createJobs():Job[]{
    let jobs = [];
    for(let i = 0; i < 10; i++){
      let proj = new Job();
      proj.name = `test {i}`;
      jobs.push(proj);
    }
    return jobs;

  }

  validateProject(code:string, uuid:string): Observable<any> {
    const url = `${environment.baseURL}${this.serviceUrl}/validate/code`;

    let urlSearchParams = new URLSearchParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    urlSearchParams.append('code',code);
    if(uuid)
      urlSearchParams.append('planUUID',uuid);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  copyFullJob(project:Project,jobs:Job[],includeOffers:boolean,includeTeams:boolean): Observable<any> {
    
    const url = `${environment.baseURL}campaign/copy`;
    const ignoreKeys = ['data'];
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    let data = {
      includeOffers:includeOffers?'true':'false',
      includeTeams:includeTeams?'true':'false'
    }

    Object.keys(data).forEach(function (key) {
      if(ignoreKeys.indexOf(key) === -1)
         urlSearchParams.append(key, data[key]);
    });

    let startDate = this.datePipe.transform(project.startDate);
    let endDate = this.datePipe.transform(project.endDate);
    if(project.uuid){
      urlSearchParams.append('planUUID',project.uuid);
    }
    urlSearchParams.append('code',project.code);

    urlSearchParams.append('name',project.name);
    urlSearchParams.append('startDate',startDate);
    urlSearchParams.append('endDate',endDate);

    urlSearchParams.append('data',JSON.stringify(jobs));
    let bodyParams = urlSearchParams.toString();

    return this.http.post<Job>(url,bodyParams,{
      headers: headers
    });

  }

  getPageBackgrounds(): Observable<any> {
    const url = `${environment.baseURL}pagebackground/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(url,{
       //params : httpParams
       headers: headers
    })

  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/job.service.ts